import React from "react";

import "../styles/components/Footer.scss";

function Footer() {
    return (
        <div className="Footer">
            <i class="bi bi-c-circle"></i>
            <p>TabbyTech Solutions 2024</p>
        </div>
    );
}

export default Footer;
